import L from "leaflet";
import { Marker, Popup } from "react-leaflet";
import PropTypes from "prop-types";

import YellowCircleMarker from "assets/images/mapMarkers/YellowCircleMarker.svg";
import OrangeCircleMarker from "assets/images/mapMarkers/OrangeCircleMarker.svg";
import GreenCircleMarker from "assets/images/mapMarkers/GreenCircleMarker.svg";
import BlackCircleMarker from "assets/images/mapMarkers/BlackCircleMarker.svg";

import "./TrackingMarker.scss";

function Markers({ data, coords, type, pacificCrossed }) {
  const status = data.organization.shipment_status;
  const shipmentId = data.organization.shipment_id;

  const {
    pickup_address_name,
    pickup_city,
    pickup_country,
    pickup_postal_code,
    stop1_city,
    stop1_country,
    stop1_address_name,
    stop1_postal_code,
  } = data.schedule;

  const getMarkerIcon = (status) => {
    let iconUrl = "";
    switch (status) {
      case "In transit":
        iconUrl = GreenCircleMarker;
        break;
      case "Delivered":
        iconUrl = GreenCircleMarker;
        break;
      case "Delayed":
        iconUrl = OrangeCircleMarker;
        break;
      case "Incomplete":
        iconUrl = YellowCircleMarker;
        break;
      default:
        iconUrl = BlackCircleMarker;
        break;
    }
    return new L.Icon({
      iconUrl,
      iconSize: new L.Point(25, 41),
    });
  };

  // If the marker is on the other side of the antimeridian, we need to add 360 to the longitude
  const formatCoords = (coords) => {
    const [lat, lng] = coords;
    if (pacificCrossed) {
      if (lng < 0) return [lat, lng + 360];
    }
    return [lat, lng];
  };

  return (
    <>
      <Marker
        icon={getMarkerIcon(status)}
        eventHandlers={{
          mouseover: (event) => {
            event.target.openPopup();
          },
          mouseout: (event) => event.target.closePopup(),
        }}
        key={shipmentId}
        position={formatCoords(coords)}
        title={`${shipmentId}`}
      >
        <Popup autoPan closeButton={false}>
          {type === "origin" && (
            <div>
              <b>Origin</b>
              <p className="mt-0">
                {pickup_address_name && `${pickup_address_name} `}
                <br />
                {pickup_city}
                <br />
                {pickup_country}, {pickup_postal_code}
              </p>
            </div>
          )}
          <div />
          {type === "destination" && (
            <div>
              <b>Destination</b>
              <p className="mt-0">
                {stop1_address_name && `${stop1_address_name} `}
                <br />
                {stop1_city}
                <br />
                {stop1_country}, {stop1_postal_code}
              </p>
            </div>
          )}
        </Popup>
      </Marker>
      );
    </>
  );
}

Markers.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  coords: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string.isRequired,
  pacificCrossed: PropTypes.bool.isRequired,
};

export default Markers;
